import { NgModule } from "@angular/core";
import { DatePickerFormComponent } from './datepicker-form/datepicker-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DatePickerDesignComponent } from './datepicker-design/datepicker-design.component';
import { DynamicDatePickerComponent } from './dynamic-datepicker.component';
import { MaterialModule } from '../../material.module';
import { DatePickerResultComponent } from './datepicker-result/datepicker-result.component';
import { DateAdapter } from '@angular/material/core';
import { DatepickerAdapter } from './datepicker.adapter';
import { KendoModule } from '../kendo.module';
import { ConvertToDatePipe } from './datepicker.pipe';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';

@NgModule({
    declarations: [
        DynamicDatePickerComponent,
        DatePickerDesignComponent,
        DatePickerFormComponent, 
        DatePickerResultComponent,
        ConvertToDatePipe,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        AbwConditionalFormatingModule
    ],
    entryComponents: [
        DynamicDatePickerComponent
    ],
    providers: [
        { provide: DateAdapter, useClass: DatepickerAdapter }
    ]
})
export class DatePickerModule {}